/**
 * Constrói a URL completa de uma imagem do backend
 * @param imagePath - Caminho da imagem retornado pelo backend (ex: /storage/logos/arquivo.jpg)
 * @returns URL completa da imagem ou null se o path for inválido
 */
export const getImageUrl = (imagePath?: string | null): string | null => {
  if (!imagePath) return null;

  // Se já é uma URL completa, retornar como está
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Pegar a URL base da API e remover o /api no final
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  const baseUrl = apiUrl.replace('/api', '');

  // Garantir que o path começa com /
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;

  return `${baseUrl}${cleanPath}`;
};
